export default "__VITE_ASSET__6c99c994__"